import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: (id, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/common/togglefeaturev2.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
    },
  }),
};
